// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"_d0b48ec","dataRow":"_8d069e0","icon":"_5416940","text":"_d83f91d","textLink":"_d9d7c55"};